import UploadHubModalAdd from 'components/UploadHub/UploadHubModalAdd';
import { useEffect, useRef, useState } from 'react';
import useUploadFiles from 'api/hooks/useUploadFiles';
import { SkeletonContent } from 'components/WritingAssistant/ui/MyContent';
import type { UploadHubListItem } from 'api/services/uploadFileService';
import UploadHubItem from './UploadHubItem';
import UploadHubDeleteModal from 'components/UploadHub/UploadHubDeleteModal';
import useEnsureUploadHubBranding from 'components/UploadHub/useEnsureUploadHubBranding';

const UploadHub = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState<boolean>(false);
  const [itemId, setItemId] = useState<string | number | null>(null);
  const [files, setFiles] = useState<UploadHubListItem[]>([]);
  const { getUploadHubList } = useUploadFiles();
  const { ensureBranding } = useEnsureUploadHubBranding();

  const fetchFiles = useRef<((signal: AbortSignal) => Promise<void>) | null>(null);
  fetchFiles.current = async (signal) => {
    try {
      await ensureBranding(signal);
      const results = await getUploadHubList({ signal });
      if (results) {
        setFiles(results);
        setIsLoading(false);
      }
    } catch {
      //Already use toaster
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    fetchFiles.current?.(controller.signal);
    return () => controller.abort('Upload hub list cancelled.');
  }, []);

  return (
    <>
      <div className={`bg-white monitor-items-bar`}>
        <div className='mx-auto main-content-wrapper flex-centered justify-content-between resize-elements-container'>
          <div className='side-left-element pl-md-5 pl-3 d-none d-lg-inline-block'>
            <p className={`mb-0 title-h4 nowrap-item monitor-dropdown-item`}>Upload hub</p>
          </div>
          <div className='main-content flex-centered position-relative filters-general-container justify-content-end pr-xl-5 px-md-4 px-3'>
            <button className='general-button action-button px-4 py-2 rounded-pill' onClick={() => setIsOpen(true)}>
              <span className='icon-upload mr-2 d-inline-block-centered'></span>Upload file
            </button>
          </div>
        </div>
      </div>
      <div className={`row mx-auto main-content-wrapper align-items-start flex-grow-1 pt-5`}>
        <div className='w-100 px-xl-5 px-md-4 px-3 h-100 mx-auto'>
          <h3 className='title-h4-bold mb-3'>{"My team's files"}</h3>
          <div className='box-top-rounded h-100 p-lg-5 p-3'>
            {isLoading ? (
              <SkeletonContent />
            ) : files.length > 0 ? (
              <ul className='policy-list px-0 items-list'>
                {files.map((file) => {
                  const { id } = file;
                  return (
                    <>
                      <UploadHubItem
                        deleteItemState={{ setItemId, setIsOpen: setIsOpenDeleteModal }}
                        key={`item-${id}`}
                        file={file}
                      />
                    </>
                  );
                })}
              </ul>
            ) : (
              <p className='text-center mt-5 pt-5 title-h4 main-light-text px-5 mt-5 pt-lg-5'>
                Files you upload will appear here
              </p>
            )}
          </div>
        </div>
      </div>
      <UploadHubModalAdd filesState={{ listFiles: files, setListFiles: setFiles }} openState={{ isOpen, setIsOpen }} />
      <UploadHubDeleteModal
        filesState={{ files, setFiles }}
        openState={{ isOpen: isOpenDeleteModal, setIsOpen: setIsOpenDeleteModal }}
        itemIdState={{ itemId, setItemId }}
      />
    </>
  );
};

export default UploadHub;
